import type { RemoteConfig } from '@funtech-int/yango-shared';
import { LegacySportBroadcastPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { ProfileManager } from '@/shared/lib/profileManager';

import type { PlayerFeatureFlags } from '../../../lib/featureFlags';
import { TelemetryContentPlace, TelemetryContentType } from '../../Player/types';
import { getEmptyPreferredTracks } from '../../feature-player/utils/config/get-empty-preferred-tracks';
import { getOnlineStreamsConfig } from '../../feature-player/utils/config/get-online-streams-config';

interface Dependencies {
    profileManager: ProfileManager;
    featureFlags: PlayerFeatureFlags;
    remoteConfig: RemoteConfig;
}

interface Props {
    telemetryContentPlace: TelemetryContentPlace;
}

export const getSportLivePlayerConfig = (
    sport: LegacySportBroadcastPlayerBaseInfoContent,
    { telemetryContentPlace }: Props,
    deps: Dependencies
) =>
    getOnlineStreamsConfig(
        {
            contentId: sport.sportBroadcastContentId,
            telemetry: {
                from_block: telemetryContentPlace,
                stream_block: TelemetryContentType.SportLive,
            },
            onlineStreams: sport.onlineStreams ?? undefined,
            preferredTracks: getEmptyPreferredTracks(),
            fetchSubtitles: true,
        },
        deps
    );
